export default __webpack_public_path__ + "static/media/Enhanced-Geyser-Benefit.e27a4d20.pdf";